export default {
  product_categories: [],
  materials: {
    results: [],
  },
  materialsVid: {
    results: [],
  },
  materialRemains: [],
  materialsForEntering: {
    results: [],
  },
  details_modal:{
    results:[]
  },
  material_for_builds:{
    results:[]
  },
}
